import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import Render from "source/app/presentation/Shared/Render";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { HandleDreamDifficultyQuickSelectionAsync } from "../QuickSelector/DreamDifficultyQuickSelector";

export function UpDownDifficultySelector({
    dream,
    ToggleQuickSelector,
    onDifficultyChanged,
    hideDifficultyArrows = false,
}: {
    dream: IDream;
    ToggleQuickSelector: () => void;
    onDifficultyChanged: () => void;
    hideDifficultyArrows?: boolean;
}) {
    return (
        <span style={{ display: `inline-flex`, alignItems: `center` }}>
            <span
                style={{
                    display: hideDifficultyArrows ? `none` : undefined,
                }}
                aria-hidden={hideDifficultyArrows}
            >
                <Render
                    id="upshiftDreamDifficulty"
                    when={dream.difficulty < maxDecisionDreamDifficulty}
                >
                    <IconWithText
                        iconSuffix={EGlyphicon["arrow-up"]}
                        whenClicked={async () => {
                            onDifficultyChanged();
                            await HandleDreamDifficultyQuickSelectionAsync(
                                dream,
                                dream.difficulty + 1
                            );
                        }}
                        displayAsBlock={false}
                        withClass={arrowStyleClass}
                    />
                </Render>
            </span>
            <span>
                <Hyperlink
                    whenClicked={() => ToggleQuickSelector()}
                    classes={difficultyNumberStyleClass}
                >
                    {dream.difficulty}
                </Hyperlink>
            </span>
            <span
                style={{
                    display: hideDifficultyArrows ? `none` : undefined,
                }}
                aria-hidden={hideDifficultyArrows}
            >
                <Render
                    id="downshiftDreamDifficulty"
                    when={dream.difficulty > minDecisionDreamDifficulty}
                >
                    <IconWithText
                        iconSuffix={EGlyphicon["arrow-down"]}
                        whenClicked={async () => {
                            onDifficultyChanged();
                            await HandleDreamDifficultyQuickSelectionAsync(
                                dream,
                                dream.difficulty - 1
                            );
                        }}
                        displayAsBlock={false}
                        withClass={arrowStyleClass}
                    />
                </Render>
            </span>
        </span>
    );
}

const maxDecisionDreamDifficulty = 11;
const minDecisionDreamDifficulty = 1;

const difficultyNumberStyleClass = StyleClass(
    `upDownDifficultySelector_textSpacing`,
    {
        margin: `0 -3px`,
        padding: `2px 8px`,
        borderRadius: `4px`,
        ":hover": {
            color: `hsl(47deg 88% 78%)`,
            background: `hsl(42deg 72% 52% / 0.12)`,
            boxShadow: `0 0 7px hsl(43deg 85% 62% / 0.22)`,
        },
    }
);

const arrowStyleClass = StyleClass(`upDownDifficultySelector_arrowStyling`, {
    opacity: 0.14,
    margin: `0.25em`,
    padding: `0.35em`,
    borderRadius: `4px`,
    ":hover": {
        opacity: 0.9,
        color: `hsl(47deg 88% 78%)`,
        background: `hsl(42deg 72% 52% / 0.12)`,
        boxShadow: `0 0 7px hsl(43deg 85% 62% / 0.22)`,
    },
});
